<template>
  <div>
    <div>
      <q-toolbar class="bg-gray shadow-4 rounded-borders">
        <q-tabs align="left" inline-label indicator-color="#9ace25"></q-tabs>
      </q-toolbar>
    </div>

    <div id="Div9" runat="server">
      <TSZ_Listado_Presupuesto />
    </div>
  </div>
</template>
<script>
import { Cookies } from 'quasar';

import TSZ_Listado_Presupuesto from '@/components/Listados/components/TSZ_Listado_Presupuesto.vue';

import '@/components/Listados/assets/css_listado_vue.css';

import { QTabs, QRouteTab, QToolbar } from 'quasar';

export default {
  data: function () {
    return {};
  },

  components: {
    TSZ_Listado_Presupuesto,
    QTabs,
    QRouteTab,
    QToolbar
  }
};
</script>
